import { Component, OnInit } from '@angular/core';
import { TestsService } from 'src/app/shared';

@Component({
  selector: 'app-topic-status',
  templateUrl: './topic-status.component.html',
  styleUrls: ['./topic-status.component.scss']
})
export class TopicStatusComponent implements OnInit {

  topic: any = [];

  constructor(
    private TestsService: TestsService,

  ) { }

  ngOnInit() {
  }

  
}
